import React, { useContext } from 'react';
import { Tooltip } from 'react-tooltip';
import { AppDataContext } from '../../../contexts/appData';
import { ReactComponent as InfoIcon } from 'resources/img/icons/info-grey-outline.svg';
import { ReactComponent as PersonIcon } from 'resources/img/icons/person.svg';
import { ReactComponent as TrendingUpIcon } from 'resources/img/icons/trending_up.svg';
import { useQuery } from '@tanstack/react-query';
import { useMediaQuery } from '../../../libs';

const TbcBnplModal = ({ callback, data }) => {
  const { langs, api } = useContext(AppDataContext);
  const currencyId = data.currencyId;
  const price = data.productPrice;

  const isMobile = useMediaQuery('(max-width: 768px)');

  const { data: bnplData } = useQuery({
    queryKey: ['bnpl-commission', price, currencyId],
    queryFn: () =>
      api.fetchBnplCommission({
        Price: Number(price) ?? 0,
        CurrencyID: currencyId,
      }),
    enabled: price >= 0,
  });

  const bnplPriceAfterCommission = bnplData?.data?.PriceAfterCommission ?? 0;

  const onAgree = () => {
    callback(null, 'onAgree');
    callback(null, 'destroy');
  };

  const onReject = () => {
    callback(null, 'onReject');
    callback(null, 'destroy');
  };

  return (
    <div className="custom-modal-wrapper hide-scrollbar" style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', maxWidth:'624px !important', width:'100%' }}>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', padding: '0 8px', width: '100%', marginBottom: 16 }}>
        <div className="d-flex align-items-center" style={{ marginBottom: 24, marginTop: 12 }}>
          <span className={'font-bold text-black font-size-14 font-size-sm-16 font-size-md-20'} style={{ fontSize: '20px' }}>
            {langs.NM_InstallmentPlanTtitle}
          </span>
          <i className={`svg-i tbc-grey-i w-24px h-24px ml-8px`}></i>
          <i className={`svg-i credo-rounded w-24px h-24px ml-4px`}></i>
          <i className={`svg-i bog-rounded w-24px h-24px ml-4px`}></i>
        </div>
        <div style={{ fontSize: '14px', color: '#4E4E4E', marginBottom: 12 }}>{langs.NM_BnplBuySplit}</div>

        <div style={{display:isMobile ? 'column' : 'flex', justifyContent:'space-between', alignItems:'flex-end', width:'100%' }}>
          <div>
            <div className="d-flex align-items-center gap-2px" style={{ fontSize: '12px', color: '#008420' }}>
              <PersonIcon />
              {langs.NM_BnplUsersChoose}
            </div>
            <div className="d-flex align-items-center gap-2px" style={{ fontSize: '12px', color: '#008420' }}>
              <TrendingUpIcon />
              {langs.NM_BnplSellFaster}
            </div>
          </div>
        </div>
        <div className='pt-16px'>
          <div style={{display:'flex', alignItems:'flex-end', marginTop: isMobile ? 16 : 0}}>
            <div style={{position:'relative'}}>
              <svg style={{position:'absolute', top:-6, right:-9, zIndex:10, background:'white', borderRadius:'50%'}} xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 16 16" fill="none">
                <path d="M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM5.832 11.432L2.96 8.56C2.648 8.248 2.648 7.744 2.96 7.432C3.272 7.12 3.776 7.12 4.088 7.432L6.4 9.736L11.904 4.232C12.216 3.92 12.72 3.92 13.032 4.232C13.344 4.544 13.344 5.048 13.032 5.36L6.96 11.432C6.656 11.744 6.144 11.744 5.832 11.432Z" fill="#008420"/>
              </svg>

              <i className="svg-i tbc-bnpl h-28px"></i>
            </div>

            <div style={{position:'relative'}}>
              <svg style={{position:'absolute', top:-6, right:8, zIndex:10, background:'white', borderRadius:'50%'}} xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 16 16" fill="none">
                <path d="M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM5.832 11.432L2.96 8.56C2.648 8.248 2.648 7.744 2.96 7.432C3.272 7.12 3.776 7.12 4.088 7.432L6.4 9.736L11.904 4.232C12.216 3.92 12.72 3.92 13.032 4.232C13.344 4.544 13.344 5.048 13.032 5.36L6.96 11.432C6.656 11.744 6.144 11.744 5.832 11.432Z" fill="#008420"/>
              </svg>

              <i className="svg-i credo-bnpl h-28px"></i>
            </div>
            <div style={{position:'relative'}}>
              <svg style={{position:'absolute', top:-6, right:8, zIndex:10, background:'white', borderRadius:'50%'}} xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 16 16" fill="none">
                <path d="M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM5.832 11.432L2.96 8.56C2.648 8.248 2.648 7.744 2.96 7.432C3.272 7.12 3.776 7.12 4.088 7.432L6.4 9.736L11.904 4.232C12.216 3.92 12.72 3.92 13.032 4.232C13.344 4.544 13.344 5.048 13.032 5.36L6.96 11.432C6.656 11.744 6.144 11.744 5.832 11.432Z" fill="#008420"/>
              </svg>

              <i className="svg-i bog-bnpl h-28px"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="px-8px" style={{ width: '100%' }}>
        <div className="font-size-12 font-medium mb-12px" style={{ color: '#272A37' }}>
          {langs.NM_BnplItemPrice}
        </div>
        <div className="d-flex mb-16px">
          <input
            disabled
            value={price}
            name='value'
            style={{ background: '#F4F4F5', border: '1px solid #E9EAEB', maxWidth: 150, color: '#A9AAAF' }}
            className="form-control price-input border-right-radius-none border-right-0 font-medium"
          />
          <div className="d-inline-flex col-4 col-md-4 p-0 ">
            <input
              disabled
              value={langs.NM_CurrencyGel}
              name='currency'
              style={{ background: '#F4F4F5', border: '1px solid #E9EAEB', width: 80, color: '#A9AAAF' }}
              className="form-control price-input border-left-radius-none font-medium"
            />
          </div>
        </div>

        <div className="px-16px py-20px" style={{ background: '#E9F8EE', borderRadius: 12, width: '100%' }}>
          <div className="font-size-12 mb-8px" style={{ color: '#7A7A7A' }}>
            {langs.NM_BnplNoInterestSale}
          </div>

          <div className="d-flex align-items-center gap-4px">
            <div className="font-size-14 font-medium" style={{ color: '#222' }}>
              {langs.NM_BnplYouGetFull}
            </div>
            <div className="d-flex align-items-center font-size-24 font-bold" style={{ color: '#176E32' }}>
              {bnplPriceAfterCommission}₾
              <InfoIcon className="ml-4px mt-2px cursor-pointer outline-none tooltip-anchor-info-icon" />
            </div>
          </div>
        </div>

        <Tooltip
          anchorSelect=".tooltip-anchor-info-icon"
          place="top"
          opacity={1}
          style={{ backgroundColor: '#272A37', maxWidth: 'fit-content', padding: '4px 8px', borderRadius: '8px', zIndex: 1 }}
        >
          <div className="d-flex align-items-center">
            <div className="font-size-12 font-base text-white">{langs.NM_BnplTooltipFeeInfo}</div>
          </div>
        </Tooltip>
      </div>

      <div className="px-8px mt-32px" style={{ width: '100%' }}>
        <button
          className="btn font-size-14 w-100 font-medium mb-16px"
          style={{ width: '100%', backgroundColor: '#2B6ADE', fontSize: '14px', color: '#fff', borderRadius: '12px' }}
          onClick={onAgree}
        >
          გადანაწილების ჩართვა
        </button>

        <div className="text-center font-size-12" style={{ color: '#4E4E4E' }}>
          {langs.NM_BnplDisableAnytime}
        </div>
      </div>
    </div>
  );
};

export default TbcBnplModal;
